import Axios from "axios";
import header from "./auth/header";

const API_URL = process.env.API_URL + "/api/v1/";
const API_URL_V3 = process.env.API_URL + "/api/v3";

class Pengaduan {
  store(data) {
    return Axios.post(API_URL_V3 + "/complaint-service/add-complaint/", data);
  }
}

export default new Pengaduan();



// WEBPACK FOOTER //
// ./src/api/pengaduan.js